import React from 'react';
import PuchasedAllManagement from "../purchasedAll/PurchasedAllManagement";

const SellManagementAllTab = () => {
    return (
        <>
            <PuchasedAllManagement />
        </>
    );
};

export default SellManagementAllTab;
